<template>
  <el-table-column
    prop="report_number"
    sortable="custom"
    label="Leltár jegyzőkönyv"
    show-overflow-tooltip
    min-width="180"
    fixed
  >
    <template slot-scope="scope">
      <span>{{ scope.row.report_number }}</span>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: "report_number"
}
</script>

<style scoped>

</style>
